import "./i18n";

// TODO uncomment this import once all SDKs are migrated.
// Make sure you remove all the individual SDK imports from the different SDKs.
// import "~/assets/styles/globals.css";

import { Outlet } from "@tanstack/react-location";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { reactErrorHandler } from "@sentry/react";
import { ErrorBoundary } from "react-error-boundary";
import RouteTemplates from "./RouteTemplates";
import ErrorFallback from "./components/ErrorFallback";
import SentryTagManager from "./components/SentryTagManager";
import { FeatureFlagProvider } from "./context/featureFlagProvider";
import { StateManagerProvider } from "./context/stateManager";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: Infinity,
    },
  },
});

const App = () => (
  <>
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      // Report render errors to Sentry (with React component stack) while still
      // showing the fallback UI. The boundary otherwise swallows the error
      // before Sentry's global handlers can see it.
      onError={reactErrorHandler()}
    >
      <RouteTemplates>
        <QueryClientProvider client={queryClient}>
          <StateManagerProvider>
            <FeatureFlagProvider>
              <SentryTagManager>
                <Outlet />
              </SentryTagManager>
            </FeatureFlagProvider>
          </StateManagerProvider>
        </QueryClientProvider>
      </RouteTemplates>
    </ErrorBoundary>
  </>
);

export default App;
